import type { Requirement } from '../api/requirements';

const TITLE_FALLBACK_LEN = 80;
const SUMMARY_PREVIEW_LEN = 160;

export function truncate(text: string, max: number): string {
  const trimmed = text.trim();
  if (trimmed.length <= max) return trimmed;
  return trimmed.slice(0, max - 1).trimEnd() + '…';
}

export function titleOf(r: Requirement): string {
  const raw = r.rawInput?.title?.trim();
  if (raw) return raw;
  const desc = r.rawInput?.description?.trim();
  if (desc) return truncate(desc, TITLE_FALLBACK_LEN);
  return 'Ohne Titel';
}

export function summaryPreview(r: Requirement): string | null {
  const summary = r.summary?.trim();
  if (summary) return truncate(summary, SUMMARY_PREVIEW_LEN);
  const desc = r.rawInput?.description?.trim();
  return desc ? truncate(desc, SUMMARY_PREVIEW_LEN) : null;
}

export function shortId(id: string): string {
  return id.slice(0, 8);
}
